export const theInputsPage1 = [
    {
        label: 'First Name',
        placeholder: 'Your First Name',
        registerName: 'primaryParentName',
        required: {
            value: true,
            message: 'First name is required'
        },
        pattern:{}
    },
    {
        label: 'Last Name',
        placeholder: 'Your Last Name',
        registerName: 'familyName',
        required: {
            value: true,
            message: 'Last name is required'
        },
        pattern:{}
    },
    {
        label: 'Email',
        placeholder: 'Your Email',
        registerName: 'primaryEmail',
        required: {
            value: true,
            message: 'Valid email is required'
        },
        pattern:{
            value: /\S+@\S+\.\S+/,
            message: "Entered value does not match email format"
        }
    },
    {
        label: 'Phone',
        placeholder: 'Your Phone #',
        registerName: 'primaryCellphone',
        required: {
            value: true,
            message: 'Phone number is required'
        },
        pattern: {
            value: /\(\d{3}\) \d{3}-\d{4}/,
            message: 'Invalid phone number format',
          },
    },
    {
        label: 'Address',
        placeholder: 'Street Address, Apt #',
        registerName: 'addressLine1',
        required: {
            value: true,
            message: 'Address is required'
        },
        pattern:{}
    },
    {
        label: 'City',
        placeholder: 'City or town',
        registerName: 'city',
        required: {
            value: true,
            message: 'City is required'
        },
        pattern:{}
    },
    {
        label: 'State',
        placeholder: 'State',
        registerName: 'state',
        required: {
            value: true,
            message: 'State is required'
        },
        pattern:{}
    },
    {
        label: 'Zip',
        placeholder: 'Zip Code',
        registerName: 'zipcode',
        required: {
            value: true,
            message: 'Zip code is required'
        },
        pattern:{}
    }
]